export var ButtonStyle;
(function (ButtonStyle) {
    ButtonStyle["Primary"] = "button--primary";
    ButtonStyle["Secondary"] = "button--secondary";
    ButtonStyle["Outline"] = "button--outline";
    ButtonStyle["Dashed"] = "button--dashed";
    ButtonStyle["Small"] = "button--small";
    ButtonStyle["Fullwidth"] = "button--fullwidth";
    ButtonStyle["Icons"] = "button--with-icons";
    ButtonStyle["Loading"] = "button--loading";
    ButtonStyle["Centered"] = "button--centered";
    ButtonStyle["Danger"] = "button--danger";
    ButtonStyle["IconRight"] = "button--icon-to-right";
    ButtonStyle["ExpandIframe"] = "button--expand-iframe";
    ButtonStyle["ExpandImage"] = "button--expand-img";
})(ButtonStyle || (ButtonStyle = {}));
